import React, { ReactElement } from 'react';
import { BookingState } from '../booking-state/BookingState';
import { PageRoutes } from '../navigation/PageRoutes';
import { useBookingContext } from '../booking-state/UseBookingContext';
import { Redirect } from 'react-router-dom';

export interface PageProps<TPageContext> {
  pageContext: TPageContext;
}

export function withPageContext<TPageContext>(
  mapPageState: (bookingState: BookingState) => TPageContext | null,
  Page: ({ pageContext }: PageProps<TPageContext>) => ReactElement,
): () => ReactElement | null {
  return function PageWithContext() {
    const [bookingState] = useBookingContext();
    const pageContext = mapPageState(bookingState);

    if (!pageContext) {
      return <Redirect to={`../${PageRoutes.Login}`} />;
    }

    return <Page pageContext={pageContext} />;
  };
}
